import { render, staticRenderFns } from "./GameBackground.vue?vue&type=template&id=4408926e&scoped=true&"
import script from "./GameBackground.vue?vue&type=script&lang=js&"
export * from "./GameBackground.vue?vue&type=script&lang=js&"
import style0 from "./GameBackground.vue?vue&type=style&index=0&id=4408926e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4408926e",
  null
  
)

export default component.exports